import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StatusBadgeColourScheme } from './status-badge-constants';

@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrl: './status-badge.component.scss',
    standalone: false
})
export class StatusBadgeComponent implements OnChanges {
  @Input() name: string = '';
  @Input() id: string = 'ballot-status';
  @Input() colourScheme: StatusBadgeColourScheme = StatusBadgeColourScheme.Green;
  @Input() iconName: string | null = null;
  cssClass: string = '';



  ngOnChanges(changes: SimpleChanges): void {
    //console.log(`name: ${this.name}, colourScheme: ${this.colourScheme}`);
    if (this.name === 'ballot-type-badge') {
      this.id = 'header-ballot-type';
    }
    if (changes['colourScheme']) {
      this.cssClass = this.getCssClass();
    }
  }

  getCssClass(): string {
    switch (this.colourScheme) {
      case StatusBadgeColourScheme.Green:
        return 'badge green';
      case StatusBadgeColourScheme.Red:
        return 'badge red';
      case StatusBadgeColourScheme.Blue2:
        return 'badge blue2';
      case StatusBadgeColourScheme.activeBlue:
        return 'badge activeBlue';
      case StatusBadgeColourScheme.warningOrange:
        return 'badge warningOrange';
      case StatusBadgeColourScheme.grey:
        return 'badge grey';
      case StatusBadgeColourScheme.saOrange:
        return 'badge saOrange';
      default:
        return 'badge';
    }
  }
}
